module.exports = __webpack_public_path__ + "static/biancaWallpaper2-8efd7fcd37adbc3c77ef190aca12ef0c.jpg";